<template>
  <div class="candys">
    <template v-if="$root.d_qty_candys_operation > 0">
      <div class="candys-categories">
        <div class="candys-categories-container" v-if="$root.d_json_candys && $root.d_json_candys.length > 1 && $root.d_json_candys.length <= 4 && !c_should_display">
          <div class="category-item" v-for="(category, index) in $root.d_json_candys" :key="index" :class="{ 'active': (p_category_selected && p_category_selected.intCategoryId == category.intCategoryId && p_category_selected.strTitle == category.strTitle) }">
            <a @click.prevent="m_select_category(category)">{{ category.strTitle }}</a>
          </div>
        </div>
        <div class="candys-categories-slider" v-if="$root.d_json_candys && ($root.d_json_candys.length > 4 || ($root.d_json_candys.length > 1 && c_should_display))">
          <div ref="slider" class="candys-categories-slider-inner">
            <div v-for="(category, index) in $root.d_json_candys" :key="index">
              <div class="slider-category" :class="{ 'active': (p_category_selected && p_category_selected.intCategoryId == category.intCategoryId && p_category_selected.strTitle == category.strTitle) }">
                <a @click.prevent="m_select_category(category)">{{ category.strTitle }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="candys-items">
        <template v-if="c_get_candys">
          <template v-for="(candy, index) in c_get_candys">
            <div v-if="(index % 2) == 0" class="row">
              <div class="col-xs-6">
                <v-candytickethome :key="index" :p_candy="candy"></v-candytickethome>
              </div>
              <div class="col-xs-6" v-if="c_get_candys[index + 1]">
                <v-candytickethome :key="index + 1" :p_candy="c_get_candys[index + 1]"></v-candytickethome>
              </div>
            </div>
          </template>
        </template>
      </div>
    </template>
    <template v-else></template>
  </div>
</template>

<script>
import $ from "jquery";
import CandyTicketHome from "./CandyTicketHome.vue";

export default {
  name: "candycategoryhome",
  components: {
    "v-candytickethome": CandyTicketHome
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  props: {
    p_category_selected: { type: Object, default: () => null }
  },
  computed: {
    c_get_candys: function () {
      var candys = null;

      if (!this.p_category_selected) {
        if (this.$root.d_json_candys && this.$root.d_json_candys.length > 0) {
          var categories = this.$root.d_json_candys.filter(function (element) {
            return element;
          });

          this.p_category_selected = categories[0];
        }
      }

      if (this.p_category_selected) {
        candys = this.p_category_selected.Candys;
      }

      return candys;
    },
    c_should_display: function () {
      return this.windowWidth <= 767;
    }
  },
  updated() {
    $(this.$refs.slider).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 5,
      dots: false,
      arrows: false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true
          }
        }
      ]
    });
  },
  mounted() {
    window.addEventListener('resize', this.m_update_window_width);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.m_update_window_width);
  },
  methods: {
    m_select_category: function (category) {
      this.p_category_selected = category;
    },
    m_update_window_width: function () {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth <= 767) {
        $(this.$refs.slider).not('.slick-initialized').slick('unslick');

        $(this.$refs.slider).not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 5,
          dots: false,
          arrows: false,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true
              }
            }
          ]
        });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CandyCategoryHome.vue